var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["header/brand-navigation.j2"] = require( "header/brand-navigation.j2" );
dependencies["header/utility-currency.j2"] = require( "header/utility-currency.j2" );
dependencies["header/utility-account.j2"] = require( "header/utility-account.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/header/utility-navigation.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/header/utility-navigation.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("accountUrl")) {
var t_4 = t_1.accountUrl;
} else {
cb(new Error("cannot import 'accountUrl'")); return;
}
context.setVariable("accountUrl", t_4);
if(t_1.hasOwnProperty("categoryUrl")) {
var t_5 = t_1.categoryUrl;
} else {
cb(new Error("cannot import 'categoryUrl'")); return;
}
context.setVariable("categoryUrl", t_5);
output += "\n\n<nav class=\"c-utility-navigation\">\n\n    <div class=\"u-large--hide\">\n\n        ";
env.getTemplate("header/brand-navigation.j2", false, "core/templates/header/utility-navigation.j2", null, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
t_6.render(context.getVariables(), frame, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
output += t_7
output += "\n\n    </div>\n\n    <ul class=\"c-utility__ul c-utility__outer u-clearfix\">\n\n        ";
env.getTemplate("header/utility-currency.j2", false, "core/templates/header/utility-navigation.j2", null, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
t_10.render(context.getVariables(), frame, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
output += t_11
output += "\n\n        ";
env.getTemplate("header/utility-account.j2", false, "core/templates/header/utility-navigation.j2", null, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
t_14.render(context.getVariables(), frame, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
output += t_15
output += "\n\n    </ul>\n\n</nav>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/header/utility-navigation.j2"] , dependencies)